/* Обращения к существующему API. Свой механизм авторизации дэшборд не заводит:
   используется тот же токен Keycloak и тот же refresh, что и в основном
   приложении. Токен лежит в localStorage — как и там. */

const BASE = import.meta.env.VITE_API_BASE || 'https://go.7cut.video';
const TOKEN_KEY = 'access_token';

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* приватное окно — работаем без запоминания */
  }
};

export class ApiError extends Error {
  constructor(status, message, body) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

/**
 * Обновляет истёкший токен тем же эндпоинтом, что и основное приложение.
 *
 * Кука refresh_token выставлена на go.7cut.video как host-only и SameSite=Strict.
 * Дэшборд на admin.7cut.video — это другой origin, но тот же сайт (7cut.video),
 * поэтому кука до /api/v1/auth/refresh доходит. Обязателен credentials: 'include' —
 * без него браузер не приложит куку к межоригинному запросу.
 */
let refreshing = null;

async function refresh() {
  if (!refreshing) {
    refreshing = fetch(BASE + '/api/v1/auth/refresh', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: '{}',
    })
      .then(async (res) => {
        if (!res.ok) throw new ApiError(res.status, 'Сессия закончилась, войдите заново.', null);
        const data = await res.json();
        setToken(data.access_token);
        return data.access_token;
      })
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
}

export async function request(path, { method = 'GET', body, params, retry = true } = {}) {
  const url = new URL(BASE + path);
  if (params)
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '' && value !== 'all')
        url.searchParams.set(key, value);
    });

  const token = getToken();
  let res;
  try {
    res = await fetch(url, {
      method,
      credentials: 'include',
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(body ? { 'Content-Type': 'application/json' } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiError(0, 'Сервер не отвечает. Проверьте соединение.', null);
  }

  // Токен Keycloak живёт минуты: истёкший обновляем один раз и повторяем запрос.
  if (res.status === 401 && retry) {
    await refresh();
    return request(path, { method, body, params, retry: false });
  }

  if (res.status === 204) return null;

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }

  if (!res.ok) {
    const message =
      res.status === 401
        ? 'Сессия закончилась, войдите заново.'
        : res.status === 403
          ? 'Нужна роль администратора.'
          : (data && data.message) || `Ошибка сервера (${res.status}).`;
    throw new ApiError(res.status, message, data);
  }
  return data;
}

/** Уводит на существующий вход; бэкенд вернёт обратно с ?access_token= в адресе. */
export function startLogin() {
  window.location.href = `${BASE}/api/v1/auth/login?redirect=${encodeURIComponent(window.location.origin)}`;
}
